/**
 * Content Half Column Component
 * Custom HTML element for content half column section with animation support
 */
class ContentHalfColumn extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initComponent();
  }

  disconnectedCallback() {
    // Cleanup if needed
  }

  initComponent() {
    const enableAnimation = this.dataset.enableAnimation === 'true';
    const colorScheme = this.dataset.colorScheme || 'scheme-1';

    // Store references for potential future use
    this.label = this.querySelector('.content-half-column__label');
    this.heading = this.querySelector('.content-half-column__heading');
    this.cta = this.querySelector('.content-half-column__cta');

    // Initialize animation if enabled
    if (enableAnimation) {
      this.initializeAnimation();
    }

    // Handle CTA interactions
    if (this.cta) {
      this.cta.addEventListener('click', () => this.handleCTAClick());
    }
  }

  initializeAnimation() {
    // The animation is handled purely via CSS transitions
    // This method can be extended for more complex animation logic if needed
    
    // Optional: Add IntersectionObserver for scroll-based animation trigger
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.add('is-visible');
            observer.unobserve(this);
          }
        });
      }, { threshold: 0.1 });

      observer.observe(this);
    }
  }

  handleCTAClick() {
    // Optional: Add analytics or tracking here
    if (window.gtag) {
      gtag('event', 'content_half_column_cta_click', {
        section_id: this.id
      });
    }
  }

  // Method to programmatically change color scheme
  setColorScheme(scheme) {
    this.dataset.colorScheme = scheme;
  }

  // Method to toggle animation
  setAnimation(enabled) {
    this.dataset.enableAnimation = enabled ? 'true' : 'false';
  }
}

// Register the custom element
customElements.define('content-half-column', ContentHalfColumn);
